module.exports = __webpack_public_path__ + "img/53fc29686e3fdd0a7114c9e7f5f43453.png";